module.exports = __webpack_public_path__ + "img/pinterest-icon.046ca9f5.svg";